import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=dc919aa4&scoped=true"
import script from "./CampaignEdit.vue?vue&type=script&lang=js"
export * from "./CampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./CampaignEdit.vue?vue&type=style&index=0&id=dc919aa4&prod&scoped=true&lang=css"
import style1 from "./CampaignEdit.vue?vue&type=style&index=1&id=dc919aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc919aa4",
  null
  
)

export default component.exports